import { TextInputHelper, TextInputHelperProps } from './TextInputHelper';

type Props = Omit<TextInputHelperProps, 'type' | 'placeholder'>;

export const DateHelper = (props: Props) => <TextInputHelper {...props} type='date' />;
